export enum LoadingDotsNumber {
  One = 'One',
  Default = 'Default'
}
